import React from "react";
import dayjs from "dayjs";
import getIntervalDates from "./Common/getIntervalDates";

const ColumnHeader = ({ startDate = "", endDate = "", driversCount }) => {
  const dates = getIntervalDates(startDate, endDate);

  return (
    <div className="flex items-center w-full sticky top-0">
      <div className="w-[20%] bg-background py-[11px] h-10 px-6 border-b border-light-grey">
        <p className="font-poppins font-medium text-xs text-dark-gray">
          Drivers ({driversCount || 0})
        </p>
      </div>

      <div className="w-[80%] flex">
        {dates?.map((d) => (
          <div className="w-full bg-background py-2.5 h-10 border-b border-l border-light-grey">
            <div className="flex items-center justify-center">
              <p className="font-poppins font-medium text-xs text-dark-gray text-center">
                {dayjs(d).format("ddd")}
              </p>

              {dayjs(d).isSame(dayjs(), "day") ? (
                <div className="ml-1 bg-primary w-5.5 h-5.5 flex items-center justify-center rounded-full">
                  <p className="font-poppins font-medium text-xs text-white text-center">
                    {dayjs(d).format("DD")}
                  </p>
                </div>
              ) : (
                <p className="ml-1 font-poppins font-medium text-xs text-black text-center">
                  {dayjs(d).format("DD")}
                </p>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ColumnHeader;
